var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaylist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2539 4C21.6681 4 22.0039 4.33579 22.0039 4.75V16.75C22.0039 18.6671 20.1912 20 18.2539 20C16.3167 20 14.5039 18.6671 14.5039 16.75C14.5039 14.8329 16.3167 13.5 18.2539 13.5C19.0676 13.5 19.8593 13.7351 20.5039 14.1499V4.75C20.5039 4.33579 20.8397 4 21.2539 4ZM20.5039 16.75C20.5039 15.9057 19.6304 15 18.2539 15C16.8775 15 16.0039 15.9057 16.0039 16.75C16.0039 17.5943 16.8775 18.5 18.2539 18.5C19.6304 18.5 20.5039 17.5943 20.5039 16.75ZM2 5.75C2 5.33579 2.33579 5 2.75 5H16.26C16.6742 5 17.01 5.33579 17.01 5.75C17.01 6.16421 16.6742 6.5 16.26 6.5H2.75C2.33579 6.5 2 6.16421 2 5.75ZM2 12C2 11.5858 2.33579 11.25 2.75 11.25H11.25C11.6642 11.25 12 11.5858 12 12C12 12.4142 11.6642 12.75 11.25 12.75H2.75C2.33579 12.75 2 12.4142 2 12ZM2 18.25C2 17.8358 2.33579 17.5 2.75 17.5H9.25C9.66421 17.5 10 17.8358 10 18.25C10 18.6642 9.66421 19 9.25 19H2.75C2.33579 19 2 18.6642 2 18.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.a02c71a4356c5b50d7f0c135d6ce86d3.svg";
export { ForwardRef as ReactComponent };